module.exports = __webpack_public_path__ + "media/images/front/home/caja-f9398f4eb35c12314bafa9fcc13f5782.png";